import { NetsTransactionFragment, NetsTransactionPreAuthFragment } from "../../generated/gql/graphql";
import { keyBy } from "lodash-es";
import { parseTime } from "../../util/date_time";
import { DateTime } from "luxon";
import { Valid } from "luxon/src/_util";
import { sortBy } from "lodash";

export type TransactionRef = {
    createdTime: DateTime<Valid>;
} & (
    | {
          netsTransactionId: string;
          transaction: NetsTransactionFragment;
          preAuth: NetsTransactionPreAuthFragment;
      }
    | {
          netsTransactionId: string | null;
          transaction: NetsTransactionFragment;
          preAuth: null;
      }
    | {
          netsTransactionId: string;
          transaction: null;
          preAuth: NetsTransactionPreAuthFragment;
      }
);

export function mergeTransactions(
    transactions: ReadonlyArray<NetsTransactionFragment>,
    preAuths: ReadonlyArray<NetsTransactionPreAuthFragment>,
): ReadonlyArray<TransactionRef> {
    let transactionsById = keyBy(transactions, "netsTransactionId");
    let preAuthsById = keyBy(preAuths, "netsTransactionId");

    let list: ReadonlyArray<TransactionRef> = [
        ...transactions.map((transaction) => {
            const preAuth = preAuthsById[transaction.netsTransactionId || ""];
            return preAuth
                ? {
                      netsTransactionId: preAuth.netsTransactionId,
                      createdTime: parseTime(transaction.createdTime),
                      preAuth,
                      transaction,
                  }
                : {
                      netsTransactionId: transaction.netsTransactionId || null,
                      createdTime: parseTime(transaction.createdTime),
                      preAuth: null,
                      transaction,
                  };
        }),
        ...preAuths
            .filter((preAuth) => !transactionsById[preAuth.netsTransactionId])
            .map((preAuth) => ({
                netsTransactionId: preAuth.netsTransactionId,
                createdTime: parseTime(preAuth.createdTime),
                preAuth,
                transaction: null,
            })),
    ];

    return sortBy(list, "createdTime").reverse();
}
